import { connect } from 'react-redux';
import { GuidService } from 'ui-components/services/guid-service';

import * as BulkUpdateActions from '../../../../store/bulk/update/bulk.update.actions';

import Scale from '../../../../fulfillment-planner/weight/scale';

const mapDispatchToProps = (dispatch, { jobId }) => {
  return {
    onReadFromScale: (scale) => {
      dispatch(BulkUpdateActions.bulkUpdateReadFromScale(scale, jobId ?? GuidService.newGuid()));
    },
  };
};

export default connect(null, mapDispatchToProps)(Scale);
